export enum MasterDataItemStatus {
  Success = 'SUCCESS',
  Fail = 'FAIL',
}
